import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ConfigurarCuentaDTO } from '../dto/configurar-cuentaDTO';
import { ConfigurarCuentaAdministrativaDTO } from '../dto/configurar-cuenta-administrativaDTO';

@Injectable({
  providedIn: 'root',
})
export class ConfigurarCuentasService {
  private apiUrl = `${environment.apiUrl}/usuario/configurarCuenta`;
  private apiUrlAdministrador = `${environment.apiUrl}/usuario/configurarCuentaAdministrador`;
  private dataUsuario = `${environment.apiUrl}/usuario/informacionPersonal`;

  constructor(private http: HttpClient) {}

  saveConfiguracionCuenta(body: ConfigurarCuentaDTO) {
    return this.http.put(this.apiUrl, body).pipe();
  }

  saveConfiguracionCuentaAdministrativa(
    body: ConfigurarCuentaAdministrativaDTO
  ) {
    return this.http.put(this.apiUrlAdministrador, body).pipe();
  }

  saveCorreoVerificacion(body: {
    id: number;
    correoElectronicoVerificacion: string;
  }) {
    return this.http.put(this.apiUrlAdministrador, body).pipe();
  }

  getDataPersonal(idUsuario: number) {
    return this.http.get(`${this.dataUsuario}/${idUsuario}`).pipe();
  }
}
